import saveAs from "file-saver"
import JSZip from "jszip"
import config from "../../config.json"

/**
 * Generates a ZIP file containing custom client resources.
 * Processes parameters to create CSS, translation, and misc files.
 * @param {Object} parameters - Current parameters state
 * @param {Array} selectedLanguages - Array of selected language codes or ["All"]
 * @param {string} currentLanguage - Current active language code
 */
function Generate(parameters, selectedLanguages = [], currentLanguage = "fr") {
  const zip = new JSZip()
  const ressourceFolder = zip.folder("ressource")
  let cssString = "",
    translationString = "",
    miscString = ""

  Object.keys(config.tabContent).forEach(key => {
    config.tabContent[key].forEach(element => {
      if (parameters[element.id]?.toString() !== element.default?.toString()) {
        if (element.type === "FileUpload") {
          const file = parameters[`${element.id}_file`]
          if (file && file.name && file.path) {
            ressourceFolder.file(
              file.name,
              fetch(file.path).then(r => r.blob())
            )
            if (element.tag) {
              cssString += `@include ${element.tag.replace("$value", `url("./${file.name}")`)};\n`
            }
          }
        }
        if (element.type === "ColorPicker" || element.type === "FontFamily") {
          if (element.tags?.length) {
            const values = element.tags.map(tag => `@include ${tag.replace("$value", parameters[element.id])};\n`)
            values.map(value => (cssString += value))
          }

          if (element.tag) {
            cssString += `@include ${element.tag.replace("$value", parameters[element.id])};\n`
          }
        }
        if (element.tag === "Translation") {
          translationString += `"${element.id}": "${parameters[element.id]}",\n`
        }
        if (element.tag === "Misc") {
          miscString += `${element.id}: ${parameters[element.id]}\n`
        }
      }
    })
  })

  translationString += `"currentLanguage": "${currentLanguage}",\n`

  if (selectedLanguages.length > 0) {
    const filteredSelectedLanguages = selectedLanguages.filter(lang => lang !== currentLanguage)
    translationString += `"selectedLanguages": ${JSON.stringify(filteredSelectedLanguages)},\n`
  }

  if (cssString) {
    zip.file("custom.scss", config.cssModel.replace("$value", cssString))
  }
  if (translationString) {
    zip.file("translation.json", config.translationModel.replace("$value", translationString).replace(/,(?=[^,]*$)/, ""))
  }
  if (miscString) {
    zip.file("misc.txt", miscString)
  }

  zip.generateAsync({ type: "blob" }).then(function (content) {
    saveAs(content, "ClientCusto.zip")
  })
}

export default Generate
